import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Historique_ancien
import Historique from "../pages/Historique_ancien/Historique"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"



// Cycle
import Cycle from "../pages/Cycle/Cycle"
import EditCycle from "../pages/Cycle/EditCycle"

// Niveau
import Niveau from "../pages/Niveau/Niveau"
import EditNiveau from "../pages/Niveau/EditNiveau"

import Tirage from "../pages/Tirage/Tirage"

// Specialite
import Specialite from "../pages/Specialite/Specialite"
import EditSpecialite from "../pages/Specialite/EditSpecialite"

// Groupe
import Groupe from "../pages/Groupe/Groupe"
import EditGroupe from "../pages/Groupe/EditGroupe"
import DetailGroupe from "../pages/Groupe/DetailGroupe"
import ViewGroupCour from "../pages/Groupe/ViewGroupCour"
import ViewGroupTD from "../pages/Groupe/ViewGroupTD"
import ViewGroupTP from "../pages/Groupe/ViewGroupTP"

// Module
import Module from "../pages/Modules/Module"
import EditModuleSpec from "../pages/Modules/EditModuleSpec"
import EditModule from "../pages/Modules/EditModule"
import DetailModuleSpecialite from "../pages/Modules/DetailModuleSpecialite"

// Matiere
import Matiere from "../pages/Matieres/Matiere"
import EditMatiere from "../pages/Matieres/EditMatiere"
import EditMatiereModule from "../pages/Matieres/EditMatiereModule"
import DetailMatiereModule from "../pages/Matieres/DetailMatiereModule"
import MatieresEnseignants from "../pages/Matieres/MatieresEnseignants"

// Enseignant
import Enseignant from "../pages/Enseignant/Enseignant"
import EditEnseignant from "../pages/Enseignant/EditEnseignant"
import DetailEnseignants from "../pages/Enseignant/DetailEnseignants"
import EnseignantsGroupes from "../pages/Enseignant/EnseignantsGroupes"
import FicheVoeux from "../pages/Enseignant/FicheVoeux"

// Grade Enseignant
import Grade from "../pages/Grades/Grade"
import EditGrade from "../pages/Grades/EditGrade"

// Statut Enseignant
import Statut from "../pages/Statuts/Statut"
import EditStatut from "../pages/Statuts/EditStatut"

// Diplome Enseignant
import Diplome from "../pages/Diplome/Diplome"
import EditDiplome from "../pages/Diplome/EditDiplome"
// Département
import Departement from "../pages/Departement/Departement"
import EditDepartement from "../pages/Departement/EditDepartement"
import EditAffectation from "../pages/Departement/EditAffectation"


// Etudiant
import Etudiant from "../pages/Etudiant/Etudiant"
import EditEtudiant from "../pages/Etudiant/EditEtudiant"
import DetailEtudiant from "../pages/Etudiant/DetailEtudiant"

// SchedulesEnseignants
import SchedulesEnseignants from "../pages/CalendarEnseignant/SchedulesEnseignants"
import AddScheduleEnseignant from "../pages/CalendarEnseignant/AddScheduleEnseignant"
import EmploiEnseignant from "../pages/CalendarEnseignant/EmploiEnseignant"

//emploi group
import EmploiGroup from "../pages/CalendarGroupes/EmploiGroup"
import SchedulesGroups from "../pages/CalendarGroupes/SchedulesGroups"

// Emploi salle
import ScheduleSalle from "../pages/CalendarSalle/ScheduleSalle"
import EmploiSalle from "../pages/CalendarSalle/EmploiSalle"

// Calendar Exam
import CalExam from "../pages/CalendarExamen/CalExam"
import ListMatieresExam from "../pages/CalendarExamen/ListMatieresExam"

// Calendar DS2
import CalDS2 from "../pages/DS2/CalDS2"
import ListMatieresDS2 from "../pages/DS2/ListMatieresDS2"

// Compostage
import Compostage from "../pages/Compostage/Compostage"
import CompostageCon from "../pages/Compostage/CompostageCon"
import ListMatieres from "../pages/Compostage/ListMatieres"
import ListSalle from "../pages/Compostage/ListSalle"

// Note examen
import NoteExamen from "pages/NoteExamen/NoteExamen"
import NoteExamenCon from "pages/NoteExamen/NoteExamenCon"
import ListMatieresNote from "../pages/NoteExamen/ListMatieresNote"
import ListEtudiantNote from "../pages/NoteExamen/ListEtudiantNote"

// DS2
import NoteDS2 from "pages/NoteDS2/NoteDS2"
import ListMatieresNoteDS2 from "../pages/NoteDS2/ListMatieresNoteDS2"
import ListMatieresNoteDS2Deux from "../pages/NoteDS2/ListMatieresNoteDS2Deux"
import ListEtudiantNoteDS2 from "../pages/NoteDS2/ListEtudiantNoteDS2"
import ListEtudiantNoteDS2Deux from "../pages/NoteDS2/ListEtudiantNoteDS2Deux"


// Surveillance
import Surveillance from "../pages/Surveillance/Surveillance"

import SurveillanceJour from "../pages/SurveillanceJour/SurveillanceJour"

//Salle
import Salle from "../pages/Salle/Salle"
import EditSalle from "../pages/Salle/EditSalle"

//Demande
import AttestationPresence from "../pages/Demandes/AttestationPresence"

// note
import NoteDS from "pages/NoteDS/NoteDS"
import AddNoteDS from "pages/NoteDS/AddNoteDS"

// ListAbsence
import ListAbsence from "pages/ListAbsence/ListAbsence"
import EnseignantAbsence from "pages/ListAbsence/EnseignantAbsence"
import Seance from "pages/ListAbsence/Seance"
import EditAbsence from "pages/ListAbsence/EditAbsence"

//
import Rattrapage from "pages/Rattrapage/Rattrapage"


import AvisTest from "pages/Test/AvisTest"

// Espace Mastere
import ListInscription from "../pages/EspaceMastere/Inscription/ListInscription"
import FicheVoeuxEns from "pages/Enseignant/FicheVoeuxEns"
import AttestationPresenceArchive from "../pages/Demandes/AttestationPresenceArchive";
import PageAutorisation from "../pages/PageAutorisation";
import PlanEtude from "../pages/PlanEtude/PlanEtude";
import InstitutOrigin from "../pages/InstitutOrigin/InstitutOrigin";
import EditInstitutOrigin from "../pages/InstitutOrigin/EditInstitutOrigin";
import EditSpecialiteEnseignant from "../pages/SpecialiteEnseignant/EditSpecialiteEnseignant";
import SpecialiteEnseignant from "../pages/SpecialiteEnseignant/SpecialiteEnseignant";


///Gestion utilisateur

import User from "pages/GestionUtilisateur/User"
import DetailUser from "../pages/GestionUtilisateur/DetailUser";
import ModifUser from "../pages/GestionUtilisateur/ModifUser";
import Semestre from "../pages/Semestre/Semestre";
import EditSemstre from "../pages/Semestre/EditSemstre";
import Administration from "../pages/Administration/Administration";
import EditAdministration from "../pages/Administration/EditAdministration";
import QuartExamen from "../pages/QuartExamen/QuartExamen"
import ResultatExamen from "../pages/ResultatExamen/ResultatExamen"
import Registre from "../pages/Registre/Registre"
import ResetPassword from "../pages/Authentication/ResetPassword"
import Quart from "../pages/Quart/Quart"
import EditQuart from "../pages/Quart/EditQuart"


///HISTORIQUE
import HistoriqueGrade from "../pages/Historique/HistoriqueGrade/HistoriqueGrade";
import HistoriqueStatus from "../pages/Historique/HistoriqueStatus/HistoriqueStatus";
import HistoriqueDiplome from "../pages/Historique/HistoriqueDiplome/HistoriqueDiplome";
import HistoriquePermutation from "../pages/Historique/HistoriquePermutation/HistoriquePermutation";
import HistoriqueSalle from "../pages/Historique/HistoriqueSalle/HistoriqueSalle";
import HistoriqueSpecialite from "../pages/Historique/HistoriqueSpecialite/HistoriqueSpecialite";
import HistoriqueMatiere from "../pages/Historique/HistoriqueMatiere/HistoriqueMatiere";
import HistoriqueModule from "../pages/Historique/HistoriqueModule/HistoriqueModule";
import HistoriqueModuleMatiere from "../pages/Historique/HistoriqueModuleMatiere/HistoriqueModuleMatiere";
import HistoriqueSeance from "../pages/Historique/HistoriqueSeance/HistoriqueSeance";
import HistoriqueGroupeExamen from "../pages/Historique/HistoriqueGroupeExamen/HistoriqueGroupeExamen";
import HistoriqueGroupeEnseignantMatiere  from "../pages/Historique/HistoriqueGroupeEnseignantMatiere/HistoriqueGroupeEnseignantMatiere";
import HistoriqueActivationEnseignant  from "../pages/Historique/HistoriqueActivationEnseignant/HistoriqueActivavtionEnseignant";
import HistoriqueDemandeTerrain from "../pages/Historique/HistoriqueDemandeTerrain/HistoriqueDemandeTerrain";
import HistoriqueVueEmploi from "../pages/Historique/HistoriqueVueEmploi/HistoriqueVueEmploi";
import HistoriqueModifCapaciteGroup  from "../pages/Historique/HistoriqueModifCapaciteGroup/HistoriqueModifCapaciteGroup";
import HistoriqueEnseignant from "../pages/Historique/HistoriqueEnseignant/HistoriqueEnseignant";
import HistoriqueVueSurveillance from "../pages/Historique/HistoriqueVueSurveillance/HistoriqueVueSurveillance";
import AffectationSujet from "../pages/Affectation/AffectationSujet"
import PlanEtudeEtat from "../pages/EtatAffecatation/PlanEtudeEtat"
import CalDS1 from "../pages/DS1/CalDS1"
import ListMatieresDS1 from "../pages/DS1/ListMatieresDS1"
import NoteDS1 from "../pages/NoteDS1/NoteDS1"
import ListMatieresNoteDS1 from "../pages/NoteDS1/ListMatieresNoteDS1"
import ListMatieresNoteDS1Deux from "../pages/NoteDS1/ListMatieresNoteDS1Deux"
import ListEtudiantNoteDS1 from "../pages/NoteDS1/ListEtudiantNoteDS1"
import ListEtudiantNoteDS1Deux from "../pages/NoteDS1/ListEtudiantNoteDS1Deux"
import NatureLicence from "../pages/GestionMastere/NatureLicence/NatureLicence"
import EditNatureLicence from "../pages/GestionMastere/NatureLicence/EditNatureLicence"
import EtablissementOrigine from "../pages/GestionMastere/EtablissementOrigine/EtablissementOrigine"
import EditEtablissementOrigine from "../pages/GestionMastere/EtablissementOrigine/EditEtablissementOrigine"
import DiplomeMastere from "../pages/GestionMastere/DiplomeMastere/DiplomeMastere"
import EditDiplomeMastere from "../pages/GestionMastere/DiplomeMastere/EditDiplomeMastere"
import SpecialiteMastere from "../pages/GestionMastere/SpecialiteMastere/SpecialiteMastere"
import MatiereSpecialite from "../pages/GestionMastere/MatiereSpecialite/MatiereSpecialite"
import Parametrage from "../pages/GestionMastere/Parametrage/Parametrage"
import ParametrageOrientation from "../pages/GestionOrientation/Parametrage/Parametrage"
import Candidat from "../pages/GestionMastere/Candidat/Candidat"
import ViewCandidat from "../pages/GestionMastere/Candidat/ViewCandidat"
import HistoriqueUser from "../pages/GestionUtilisateur/HistoriqueUser"
import SpecialiteOrientation from "../pages/GestionOrientation/SpecialiteOrientation/SpecialiteOrientation"
import MatiereOrientation from "../pages/GestionOrientation/MatiereOrientation/MatiereOrientation"
import EtudiantOrientation from "../pages/GestionOrientation/EtudiantOrientation/EtudiantOrientation"
import EtudiantImportation from "../pages/GestionOrientation/EtudiantImportation/EtudiantImportation"

const authProtectedRoutes = [
  /// Gestion Mastère
  { path: "/NatureLicence", component: NatureLicence },
  { path: "/EditNatureLicence", component: EditNatureLicence },
  /// EtablissementOrigine
  { path: "/EtablissementOrigine", component: EtablissementOrigine },
  { path: "/EditEtablissementOrigine", component: EditEtablissementOrigine },
  /// Diplome mastere
  { path: "/DiplomeMastere", component: DiplomeMastere },
  { path: "/EditDiplomeMastere", component: EditDiplomeMastere },
  /// Specialite Mastere
  { path: "/SpecialiteMastere", component: SpecialiteMastere },
  /// Specialite Mastere
  { path: "/MatiereSpecialite", component: MatiereSpecialite },
  /// Parametrage
  { path: "/Parametrage", component: Parametrage },
  /// Parametrage
  { path: "/Candidat", component: Candidat },
  { path: "/ViewCandidat", component: ViewCandidat },
  { path: "/HistoriqueUser", component: HistoriqueUser },

  ///Gestion orientation
  { path: "/ParametrageOrientation", component: ParametrageOrientation },
  //SpecialiteOrientation
  { path: "/SpecialiteOrientation", component: SpecialiteOrientation },
  //MatiereOrientation
  { path: "/MatiereOrientation", component: MatiereOrientation },
  //Liste des condidats
  { path: "/ListEtudiantOrientation", component: EtudiantOrientation },
  { path: "/ListEtudiantImportation", component: EtudiantImportation },
  ///

  { path: "/Affectation", component: AffectationSujet },
  { path: "/EtatEncadrement", component: PlanEtudeEtat },
  // HISTORIQUE
  { path: "/historiqueGrade", component: HistoriqueGrade },
  { path: "/historiqueStatus", component: HistoriqueStatus },
  { path: "/historiqueDiplome", component: HistoriqueDiplome },
  { path: "/HistoriquePermutation", component: HistoriquePermutation },
  { path: "/HistoriqueSalle", component: HistoriqueSalle },
  { path: "/HistoriqueSpecialite", component: HistoriqueSpecialite },
  { path: "/HistoriqueMatiere", component: HistoriqueMatiere },
  { path: "/HistoriqueModule", component: HistoriqueModule },
  { path: "/HistoriqueModuleMatiere", component: HistoriqueModuleMatiere },
  { path: "/HistoriqueSeance", component: HistoriqueSeance },
  { path: "/HistoriqueGroupExamen", component: HistoriqueGroupeExamen },
  {
    path: "/HistoriqueGroupEnsMatiere",
    component: HistoriqueGroupeEnseignantMatiere,
  },
  {
    path: "/HistoriqueActivationEnseignant",
    component: HistoriqueActivationEnseignant,
  },
  { path: "/HistoriqueDemandeTerrain", component: HistoriqueDemandeTerrain },
  { path: "/HistoriqueVueEmploi", component: HistoriqueVueEmploi },
  { path: "/HistoriqueVueSurveillance", component: HistoriqueVueSurveillance },
  {
    path: "/HistoriqueModifCapaciteGroup",
    component: HistoriqueModifCapaciteGroup,
  },
  { path: "/HistoriqueEnseignant", component: HistoriqueEnseignant },
  // Registre
  { path: "/Registre", component: Registre },
  // PageAutorisation
  { path: "/PageAutorisation", component: PageAutorisation },

  // Resultat examen
  { path: "/ResultatExamen", component: ResultatExamen },
  ///Semestre
  { path: "/Semestre", component: Semestre },
  { path: "/EditSemestre", component: EditSemstre },
  // QuartExamen
  { path: "/QuartExamen", component: QuartExamen },
  { path: "/Quart", component: Quart },
  { path: "/EditQuart", component: EditQuart },
  //Administration
  { path: "/Administration", component: Administration },
  { path: "/EditAdministration", component: EditAdministration },

  // Gestion Utilisateur
  { path: "/User", component: User },
  { path: "/DetailUser", component: DetailUser },
  { path: "/ModifUser", component: ModifUser },

  // profile
  { path: "/PlanEtude", component: PlanEtude },

  { path: "/dashboard", component: Dashboard },
  // diplome
  { path: "/Diplome", component: Diplome },
  { path: "/EditDiplome", component: EditDiplome },

  // profile
  { path: "/profile", component: UserProfile },

  // Historique_ancien
  { path: "/Historique_ancien", component: Historique },

  // Cycle
  { path: "/Cycle", component: Cycle },
  { path: "/EditCycle", component: EditCycle },

  // Niveau
  { path: "/Niveau", component: Niveau },
  { path: "/EditNiveau", component: EditNiveau },

  // Specialite
  { path: "/Specialite", component: Specialite },
  { path: "/EditSpecialite", component: EditSpecialite },

  // Groupe
  { path: "/Groupe", component: Groupe },
  { path: "/EditGroupe", component: EditGroupe },
  { path: "/DetailGroupe", component: DetailGroupe },
  { path: "/ViewGroupCour", component: ViewGroupCour },
  { path: "/ViewGroupTD", component: ViewGroupTD },
  { path: "/ViewGroupTP", component: ViewGroupTP },

  // Module
  { path: "/Module", component: Module },
  { path: "/EditModuleSpec", component: EditModuleSpec },
  { path: "/EditModule", component: EditModule },
  { path: "/DetailModuleSpecialite", component: DetailModuleSpecialite },

  // Matiere
  { path: "/Matiere", component: Matiere },
  { path: "/EditMatiere", component: EditMatiere },
  { path: "/EditMatiereModule", component: EditMatiereModule },
  { path: "/DetailMatiereModule", component: DetailMatiereModule },
  { path: "/MatieresEnseignants", component: MatieresEnseignants },

  // Enseignant
  { path: "/Enseignant", component: Enseignant },
  { path: "/EditEnseignant", component: EditEnseignant },
  { path: "/DetailEnseignants", component: DetailEnseignants },
  { path: "/EnseignantsGroupes", component: EnseignantsGroupes },
  { path: "/FicheVoeux", component: FicheVoeux },
  { path: "/FicheVoeuxEns", component: FicheVoeuxEns },

  // Grade Enseignant
  { path: "/Grade", component: Grade },
  { path: "/EditGrade", component: EditGrade },

  // Statut Enseignant
  { path: "/Statut", component: Statut },
  { path: "/EditStatut", component: EditStatut },

  // Département
  { path: "/Departement", component: Departement },
  { path: "/EditDepartement", component: EditDepartement },
  { path: "/EditAffectation", component: EditAffectation },

  // Etudiant
  { path: "/Etudiant", component: Etudiant },
  { path: "/EditEtudiant", component: EditEtudiant },
  { path: "/DetailEtudiant", component: DetailEtudiant },

  // SchedulesEnseignants
  { path: "/SchedulesEnseignants", component: SchedulesEnseignants },
  { path: "/AddScheduleEnseignant", component: AddScheduleEnseignant },
  { path: "/EmploiEnseignant", component: EmploiEnseignant },

  //emploi group
  { path: "/EmploiGroup", component: EmploiGroup },
  { path: "/SchedulesGroups", component: SchedulesGroups },

  //emploi salle
  { path: "/ScheduleSalle", component: ScheduleSalle },
  { path: "/EmploiSalle", component: EmploiSalle },

  // Calendar Exam
  { path: "/CalExam", component: CalExam },
  { path: "/ListMatieresExam", component: ListMatieresExam },

  // Calendar ds2
  { path: "/CalDS2", component: CalDS2 },
  { path: "/ListMatieresDS2", component: ListMatieresDS2 },
  // Calendar ds1
  { path: "/CalDS1", component: CalDS1 },
  { path: "/ListMatieresDS1", component: ListMatieresDS1 },

  // Compostage
  { path: "/Compostage", component: Compostage },
  { path: "/CompostageCon", component: CompostageCon },
  { path: "/ListMatieres", component: ListMatieres },
  { path: "/ListSalle", component: ListSalle },

  // Surveillance
  { path: "/Surveillance", component: Surveillance },

  { path: "/SurveillanceJour", component: SurveillanceJour },

  //Salle
  { path: "/Salle", component: Salle },
  { path: "/EditSalle", component: EditSalle },
  //insrtitut origin
  { path: "/InstitutOrigin", component: InstitutOrigin },
  { path: "/EditInstitutOrigin", component: EditInstitutOrigin },
  //Spécialités enseignant
  { path: "/SpécialitésEnseignant", component: SpecialiteEnseignant },
  { path: "/EditSpécialitésEnseignant", component: EditSpecialiteEnseignant },

  //Demande
  { path: "/AttestationPresence", component: AttestationPresence },
  {
    path: "/AttestationPresenceArchive",
    component: AttestationPresenceArchive,
  },

  // note
  { path: "/NoteDS", component: NoteDS },
  { path: "/AddNoteDS", component: AddNoteDS },
  // note
  //   { path: "/NoteDS2", component: NoteDS2 },
  // { path: "/AddNoteDS", component: AddNoteDS },

  // Absence
  { path: "/ListAbsence", component: ListAbsence },
  { path: "/EnseignantAbsence", component: EnseignantAbsence },
  { path: "/Seance", component: Seance },
  { path: "/EditAbsence", component: EditAbsence },

  //
  { path: "/Rattrapage", component: Rattrapage },

  { path: "/Tirage", component: Tirage },

  { path: "/AvisTest", component: AvisTest },

  // NoteExamenPrincipale DS2
  { path: "/NoteDS2", component: NoteDS2 },
  { path: "/ListMatieresNoteDS2", component: ListMatieresNoteDS2 },
  { path: "/ListMatieresNoteDS2Deux", component: ListMatieresNoteDS2Deux },

  { path: "/ListEtudiantNoteDS2", component: ListEtudiantNoteDS2 },
  { path: "/ListEtudiantNoteDS2Deux", component: ListEtudiantNoteDS2Deux },
  // NoteExamenPrincipale DS1
  { path: "/NoteDS1", component: NoteDS1 },
  { path: "/ListMatieresNoteDS1", component: ListMatieresNoteDS1 },
  { path: "/ListMatieresNoteDS1Deux", component: ListMatieresNoteDS1Deux },

  { path: "/ListEtudiantNoteDS1", component: ListEtudiantNoteDS1 },
  { path: "/ListEtudiantNoteDS1Deux", component: ListEtudiantNoteDS1Deux },

  // DS2
  { path: "/NoteExamen", component: NoteExamen },
  { path: "/NoteExamenCon", component: NoteExamenCon },
  { path: "/ListMatieresNote", component: ListMatieresNote },
  { path: "/ListEtudiantNote", component: ListEtudiantNote },

  // List Inscription
  { path: "/ListInscription", component: ListInscription },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/ResetPassword/:token", component: ResetPassword },
]

export { publicRoutes, authProtectedRoutes }
